import React from 'react';
import { Alert, Col, Form, Row } from 'react-bootstrap';
import { ActionButtons, Loader } from '../../../common/components';
import { LOADING_STATUS, WEEKDAYS_SHORT } from '../../../common/constants';
import { WeekdayMinimumStayRuleItemsData } from '../../../common/types/rates.types';

function WeekdayMinimumStayRestrictionsForm({
  loadingStatus,
  handleMinimumStayInputChange,
  updateWeekdayMinimumStayRuleItemsData,
  onSubmit,
  submitted,
  data,
  hasWriteAccess,
  isDefaultRate = false,
}: {
  loadingStatus: LOADING_STATUS;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleMinimumStayInputChange: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  updateWeekdayMinimumStayRuleItemsData: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  onSubmit: any;
  submitted: boolean;
  data: WeekdayMinimumStayRuleItemsData;
  hasWriteAccess: boolean;
  isDefaultRate?: boolean;
}) {
  const renderWeekdayMinimumStayRuleItems = (
    <>
      <h4 className="h5 mb-24">Varauksen vähimmäiskestot 1-7 vrk</h4>
      <Row xs={1} sm="auto">
        {WEEKDAYS_SHORT.map(weekdayItem => {
          const existingRule = data.weekdayMinimumDurations.find(
            dur => dur.weekday === weekdayItem.weekdayInt,
          );

          return (
            <Col
              key={`minimumStayRule-${weekdayItem.weekdayInt}`}
              style={{ maxWidth: 100 }}
            >
              <Form.Group
                controlId={`minimumStayRule-${weekdayItem.weekdayInt}`}
                className="mb-24"
              >
                <Form.Label>{weekdayItem.weekdayString}</Form.Label>
                <Form.Control
                  type="text"
                  name={`minimumStayRule-${weekdayItem.weekdayInt}`}
                  onChange={e =>
                    handleMinimumStayInputChange(e, weekdayItem.weekdayInt)
                  }
                  value={
                    existingRule ? existingRule.minimumDurationForCheckIn : ''
                  }
                  readOnly={!hasWriteAccess}
                />
              </Form.Group>
            </Col>
          );
        })}
      </Row>

      <Form.Group>
        <Form.Text muted>
          Varauksen tulee olla kestoltaan vähintään annettu vuorokausien määrä,
          mikäli se alkaa kyseisenä viikonpäivänä.
        </Form.Text>
      </Form.Group>
    </>
  );

  return (
    <>
      <Loader IsLoading={loadingStatus === LOADING_STATUS.LOADING} />
      {loadingStatus === LOADING_STATUS.IDLE && (
        <>
          {renderWeekdayMinimumStayRuleItems}

          <hr className="hr-light mb-32" />

          {isDefaultRate ? (
            <>
              <input type="hidden" name="isActive" value="true" />
              <input type="hidden" name="isCopyable" value="true" />
            </>
          ) : (
            <Row xs="auto">
              <Col>
                <Form.Group controlId="isActive" className="mb-24">
                  <Form.Label>Aktiivinen sääntö</Form.Label>
                  <Form.Check
                    type="checkbox"
                    name="isActive"
                    onChange={updateWeekdayMinimumStayRuleItemsData}
                    checked={data.isActive}
                    disabled={!hasWriteAccess}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="isCopyable" className="mb-24">
                  <Form.Label>Kopioitava sääntö</Form.Label>
                  <Form.Check
                    type="checkbox"
                    name="isCopyable"
                    onChange={updateWeekdayMinimumStayRuleItemsData}
                    checked={data.isCopyable}
                    disabled={!hasWriteAccess}
                  />
                </Form.Group>
              </Col>
            </Row>
          )}

          <ActionButtons
            HandleSave={onSubmit}
            HideSaveButton={!hasWriteAccess}
            HideCancelButton
            DeleteButtonText=""
          />
          {submitted && (
            <div className="mt-2 pt-2">
              <Alert variant="success">Tiedot tallennettu!</Alert>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default WeekdayMinimumStayRestrictionsForm;
